/* eslint-disable */
export default {
  loginButton: '로그인',
  signupButton: '새 사용자세요? 가입하기',
  version: '버전',
} as const;

// @key: @#@"loginButton"@#@ @source: @#@"Sign In"@#@
// @key: @#@"signupButton"@#@ @source: @#@"New user? Sign Up"@#@
// @key: @#@"version"@#@ @source: @#@"Version"@#@
